"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IntentThankYouPage;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _image = require("@site/pattern-library-core/image");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _index = _interopRequireDefault(require("../headline-lockup/index.js"));
var _baseActions = _interopRequireDefault(require("../actions/base-actions"));
var _inputBar = _interopRequireDefault(require("@site/pattern-library-core/input-bar"));
var _domainSearch = _interopRequireDefault(require("@site/pattern-library-core/domain-search"));
const Image = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Image",
  class: "pl-i1hxuwi4"
});
const ImageWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageWrapper",
  class: "pl-i19zeqft"
});
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c173i17m"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-h18fshbl"
});
const IntentThankYouPageContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IntentThankYouPageContainer",
  class: "pl-ivy057d"
});
function IntentThankYouPage({
  ctas,
  title,
  heading,
  subtitle,
  tagLabel,
  landscape,
  description,
  priceLockup
}) {
  return /*#__PURE__*/_react.default.createElement(IntentThankYouPageContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: title,
    textAlign: "start",
    headlineTag: "h2",
    description: subtitle,
    headlineSize: "h2",
    headlineLineLength: 2.5
  }), /*#__PURE__*/_react.default.createElement(_section.default, {
    dataCy: 'intent-thank-you-page-section'
  }, /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-layout": 'split'
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    ctas: ctas,
    heading: heading,
    tagLabel: tagLabel,
    description: description,
    priceLockup: priceLockup,
    headlineSize: 'h3',
    actionsLayout: 'button-set',
    headlineLineLength: 2.5
  })), landscape && /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement(Image, null, /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    loading: "eager",
    defaultSrc: landscape?.url
  }))))));
}
IntentThankYouPage.propTypes = {
  title: _propTypes.default.string,
  heading: _propTypes.default.string,
  subtitle: _propTypes.default.string,
  tagLabel: _propTypes.default.string,
  landscape: _propTypes.default.shape({
    url: _propTypes.default.string
  }),
  description: _propTypes.default.string,
  priceLockup: _propTypes.default.shape({
    price: _propTypes.default.string,
    priceTag: _propTypes.default.string,
    priceDetail: _propTypes.default.string
  }),
  ctas: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_baseActions.default), _propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape(_merchButton.NSMerchButton.propTypes), _propTypes.default.shape(_inputBar.default.propTypes), _propTypes.default.shape(_domainSearch.default.propTypes)]))])
};